export default __webpack_public_path__ + "static/media/28-blind.61b394bf.png";